import React from 'react'

import { LntModal } from '@app/components/base'

import styles from './styles.module.scss'

import { CommonConfirmDeleteExternalProductProps } from './types'

export const CommonConfirmDeleteExternalProduct: React.FC<CommonConfirmDeleteExternalProductProps> = props => {
  const { onSubmit, title, ...restProps } = props

  return (
    <LntModal
      { ...restProps }
      className={ styles.commonDeleteExternalProduct }
      title={ title }
      onOk={ onSubmit }
    />
  )
}
